import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b993eec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed-bottom TumiCookies"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xs-12 col-md-9 col-lg-10 mb-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Wij maken op onze websites gebruik van cookies. Wij gebruiken cookies voor het bijhouden van statistieken en om jouw voorkeuren op te slaan. Door op ‘Aanvaarden’ te klikken, ga je akkoord met het gebruik van alle cookies zoals omschreven in onze ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("cookieverklaring")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_8 = { class: "col-xs-12 col-md-3 col-lg-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, { name: "cookies" }, {
    default: _withCtx(() => [
      (_ctx.showPopUp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_router_link, { to: "/Cookies" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "btn btn-light",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Click && _ctx.Click(...args)))
                  }, "Aanvaarden")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}